import styled from 'styled-components'

export const Container = styled.div`
  padding: 10px 20px;
`

export const PostTitle = styled.h1`
  font-size: 3em;
  margin-bottom: 10px;
`

export const PostBody = styled.article`
  p,
  ul {
    font-size: 1em;
    margin: 1.5em 0;
    line-height: 1.5em;
  }

  p img {
    display: block;
    margin: 10px auto;
    max-width: 100%;
  }

  p img,
  pre {
    border-radius: 6px;
    margin-bottom: 1em;
  }

  p code {
    border-radius: 2px;
    padding: 3px 5px;
    background: #282b2e;
    color: #e0e2e4;
  }

  h2 {
    font-size: 2em;
    margin-top: 2em;
  }

  h2 {
    font-size: 1.8em;
  }

  h3 {
    font-size: 1.5em;
  }

  ol,
  ul {
    padding: 0 1em;
  }
`
